import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Modal, ModalBody, Button } from 'reactstrap';
import 'bootstrap/dist/css/bootstrap.min.css';

import insertlogo from '../../Assets/App_icon/insert.png';
import backlogo from '../../Assets/App_icon/back.png';

const PartyMaster = () => {
  
  const store = localStorage.getItem('store');
  const host_url = localStorage.getItem('host_url');

  const navigate = useNavigate();
  const [modalVisible, setModalVisible] = useState(false); 
  const [addmodalVisible, setAddModalVisible] = useState(false); 
  
  const [codeList, setCodeList] = useState([]);
  const [selectedCode, setSelectedCode] = useState('');
  const [catlist, setCatlist] = useState([]);

  const handleBack = () => {
    navigate('../dashboard');
  };

    useEffect(() => {
      document.title = "HSN Code";
    }, []); // for Title Set

    // Escape key press handling
    useEffect(() => {
      const handleKeyPress = (event) => {
        if (event.key === "Escape") {
          // Close modal or navigate back if no modal is open
          if (modalVisible || addmodalVisible) {
            setModalVisible(false);
            setAddModalVisible(false);
          } else {
            handleBack();
          }
        }
        
        if (event.key === "Insert" && !addmodalVisible) {
          setAddModalVisible(true);
        }
      };

      document.addEventListener("keydown", handleKeyPress);
      return () => {
        document.removeEventListener("keydown", handleKeyPress);
      };
    }, [modalVisible, addmodalVisible]);

    useEffect(() => { 
      const fetchAccountList = async () => { 
          try {
            const response = await fetch(`${host_url}/hsncode_mlist`, {
              method: 'POST', 
              headers: {
                'Content-Type': 'application/json',
              },
              body: JSON.stringify({
                type: 'list',
                store: store,
                codeDetail: '',
              }),
            });
            const data = await response.json();
            setCodeList(data);
          } catch (error) {
            console.error('Error fetching cities:', error);
          }
          
      }; 
     fetchAccountList(); 
    }, [host_url, store]); // HSM Code List

    useEffect(() => { 
      const fetchCatagoryList = async () => { 
          const formData = new FormData();
          formData.append("type", "list");
          formData.append("store", store);
          formData.append("catlist", '');

          try {
            const response = await fetch(`${host_url}/category_mlist`, {
              method: 'POST',
              body: formData,
            });
            
            const data = await response.json();
            setCatlist(data);
          } catch (error) {
            console.error('Error fetching categories:', error);
          }
      }; 
     fetchCatagoryList(); 
    }, [host_url, store]); // Categoty Fetch 
    
    const [goodsNameFilter, setGoodsNameFilter] = useState('');
    const [codeFilter, setCodeFilter] = useState('');
    const [catEnameFilter, setCatEnameFilter] = useState('');

    const filteredCodeList = codeList.filter(code =>
      String(code.GST_pcat_id).toLowerCase().includes(catEnameFilter.toLowerCase()) && 
      code.GST_goods_name.toLowerCase().includes(goodsNameFilter.toLowerCase()) &&
      code.GST_hsn_code.toLowerCase().includes(codeFilter.toLowerCase()) 
      
    );

    const totalCount = filteredCodeList.length;
   
    const handleCodeDetail = (code) => {
      setModalVisible(true);
      setSelectedCode(code);
    };

    // Functions for handling the different actions
    const handleAddCode = async () => {
      setAddModalVisible(false);
      try {
        const response = await fetch(`${host_url}/hsncode_mlist`, {
          method: 'POST', 
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            type: 'code_insert',
            store: store,
            suId : '',
            codeDetail: selectedCode,
          }),
        });
        const data = await response.json();
        setCodeList(data);
      } catch (error) {
        console.error('Error fetching cities:', error);
      }
    };

    const handleUpdateCode = async () => {
      setModalVisible(false);
      try {
        const response = await fetch(`${host_url}/hsncode_mlist`, {
          method: 'POST', 
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            type: 'code_update',
            store: store,
            codeDetail: selectedCode,
          }),
        });
        const data = await response.json();
        setCodeList(data);
      } catch (error) {
        console.error('Error fetching cities:', error);
      }
    };

     const handleDeleteCode = async () => {
      setModalVisible(false);
      try {
        const response = await fetch(`${host_url}/hsncode_mlist`, {
          method: 'POST', 
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            type: 'code_delete',
            store: store,
            codeDetail: selectedCode,
          }),
        });
        const data = await response.json();
        if (data.message) {
            alert(data.message); 
        } else {
            setCodeList(data);
        }
        
      } catch (error) {
        console.error('Error fetching cities:', error);
      }
    };

  return (
    <div className="container">
          <div style={{ display: 'flex', justifyContent: 'space-between', width: '100%' }}>
              <div onClick={handleBack}>
                <img src={backlogo} alt="Back" className='system-icon'/>
              </div>
              <b style={{ margin: '10px', fontSize: '20px' }}>HSN Code Detail</b>
              <div onClick={() => { setSelectedCode(''); setAddModalVisible(true); }}>
                <img src={insertlogo} alt="Back" className='system-icon'/>
              </div>
          </div>
                 
          <table className="table-bordered table-sm custom-hover">
            <thead>
              <tr >
                <th >Catagory</th>
                <th>HSN Code</th>
                <th colSpan='2'>Goods Name</th>
                <th>Unit</th>
                <th>Rate</th>
              </tr>
              <tr>
                <th >
                  <select
                    className="search-input"
                    value={catEnameFilter}
                    onChange={(e) => setCatEnameFilter(e.target.value)}
                  >
                    <option value="">All Category</option>
                    {catlist.map((catlist) => (
                      catlist.pcat_count > 0 && (
                        <option key={catlist.pcat_Id} value={catlist.pcat_id}>
                          {catlist.pcat_Ename}
                        </option>
                      )
                    ))}
                  </select>
                </th>
                <th >
                  <input
                    type="text"
                    className="search-input"
                    value={codeFilter}
                    onChange={(e) => setCodeFilter(e.target.value)}
                  />
                </th>
                <th colSpan='2'>
                  <input
                    type="text"
                    className="search-input"
                    value={goodsNameFilter}
                    onChange={(e) => setGoodsNameFilter(e.target.value)}
                  />
                </th>
                <th></th>
                <th></th>
              </tr>
            </thead>
            <tbody className="scrollable-body">
              {filteredCodeList.map((row, index) => {
                  return (
                    <tr key={index} style={{ lineHeight: '10px' }} onClick={() => handleCodeDetail(row)}>
                      <td className="cell-left"><span style={{ paddingLeft: '10px' }}>{row.GST_pcat_name}</span></td>
                      <td className="cell-left"><span style={{ paddingLeft: '10px' }}>{row.GST_hsn_code}</span></td>
                      <td colSpan='2'className="cell-left"><span style={{ paddingLeft: '10px' }}>{row.GST_goods_name}</span></td>
                      <td className="cell-right"><span style={{ paddingRight: '10px' }}>{row.GST_unit}</span></td>
                      <td className="cell-right"><span style={{ paddingRight: '10px' }}>{row.GST_rate}</span></td>
                    </tr>
                  );
              })}
            </tbody>
            <tfoot>
              <tr >
                <th colSpan='4' className="cell-left"><span style={{ paddingLeft: '10px' }}>{totalCount}</span></th>
              </tr>
            </tfoot>
          </table>
          

          {/* Modal for HSNcode Detail */}
            <Modal isOpen={modalVisible} toggle={() => setModalVisible(!modalVisible)} className="detailmodal" backdrop="static" keyboard={false}>
              <ModalBody style={{ backgroundColor: '#e8fadb'}}>
                <h5 >GST Detail</h5>  
                  <div >
                    <table style={{ backgroundColor: '#e8fadb', border: '0px', width: '100%' }}>
                      <tr>
                        <td className="cell-left">HSN Code</td>
                        <td><input type="text" value={selectedCode.GST_hsn_code} onChange={(e) => setSelectedCode({ ...selectedCode, GST_hsn_code: e.target.value })} /></td>
                      </tr>
                      <tr>
                        <td className="cell-left">Goods Name</td>
                        <td><input type="text" value={selectedCode.GST_goods_name} onChange={(e) => setSelectedCode({ ...selectedCode, GST_goods_name: e.target.value })} /></td>
                      </tr>
                      <tr>
                        <td className="cell-left">GST Units</td>
                        <td><select
                              value={selectedCode.GST_unit}
                              onChange={(e) => setSelectedCode({ ...selectedCode, GST_unit: e.target.value })}
                            >
                              <option value="KGS">KGS - KILOGRAMS</option>
                              <option value="NOS">NOS - NUMBERS</option>
                              <option value="BOX">BOX - BOX</option>
                              <option value="PCS">PCS - PIECES</option>
                              <option value="UNT">UNT -UNITS</option>
                              <option value="BDL">BDL - BUNDLES</option>
                              <option value="BTL">BTL - BOTTLES</option>
                              <option value="CAN">CAN - CANS</option>
                              <option value="CTN">CTN - CARTONS</option>
                              <option value="DOZ">DOZ - DOZEN</option>
                              <option value="GMS">GMS - GRAMS</option>
                              <option value="KLR">KLR - KILOLITER</option>
                              <option value="TON">TON - TONNES</option>
                              <option value="PAC">PAC - PACKS</option>                              
                              <option value="OTH">OTH - OTHERS</option>
                            </select>
                        </td>
                      </tr>
                      <tr>
                        <td className="cell-left">GST Rate</td>
                        <td><input type="text" value={selectedCode.GST_rate} onChange={(e) => setSelectedCode({ ...selectedCode, GST_rate: e.target.value.replace(/[^0-9]/g, 0).slice(0, 2) })} /></td>
                      </tr>
                      <tr>
                          <td className="cell-left">Category</td>
                          <td><select
                                value={selectedCode.GST_pcat_id}
                                onChange={(e) => setSelectedCode({ ...selectedCode, GST_pcat_id: e.target.value })}
                              >
                                {catlist.map((catlist) => (
                                    <option key={catlist.pcat_Id} value={catlist.pcat_id}>
                                      {catlist.pcat_Ename}
                                    </option>
                                ))}
                              </select>
                          </td>                      
                        </tr>
                    </table>
                  </div>
                  <div style={{ display: 'flex', justifyContent: 'space-between', width: '100%' }}>
                    <Button color="danger" style={{ flex: 1, marginRight: '10px' }} onClick={handleDeleteCode}>
                      Delete
                    </Button>
                    <Button color="success" style={{ flex: 1, marginRight: '10px' }} onClick={handleUpdateCode}>
                      Update
                    </Button>
                    <Button color="primary" style={{ flex: 1 }} onClick={() => setModalVisible(false)}>
                      Close
                    </Button>
                  </div>
                
              </ModalBody>
            </Modal>

          {/* Modal for Add New HSNcode */}
            <Modal isOpen={addmodalVisible} className="detailmodal" backdrop="static" keyboard={false}>
              <ModalBody style={{ backgroundColor: '#e8fadb'}}>
                <h5 >Add New Party</h5>  
                  <div >
                    <table style={{ backgroundColor: '#e8fadb', border: '0px', width: '100%' }}>
                      <tr>
                        <td className="cell-left">HSN Code</td>
                        <td><input type="text" value={selectedCode.GST_hsn_code} onChange={(e) => setSelectedCode({ ...selectedCode, GST_hsn_code: e.target.value })} /></td>
                      </tr>
                      <tr>
                        <td className="cell-left">Goods Name</td>
                        <td><input type="text" value={selectedCode.GST_goods_name} onChange={(e) => setSelectedCode({ ...selectedCode, GST_goods_name: e.target.value })} /></td>
                      </tr>
                      <tr>
                        <td className="cell-left">GST Units</td>
                        <td><select
                              value={selectedCode.GST_unit}
                              onChange={(e) => setSelectedCode({ ...selectedCode, GST_unit: e.target.value })}
                            >
                              <option value="">Select GST Unit</option>
                              <option value="KGS">KGS - KILOGRAMS</option>
                              <option value="NOS">NOS - NUMBERS</option>
                              <option value="BOX">BOX - BOX</option>
                              <option value="PCS">PCS - PIECES</option>
                              <option value="UNT">UNT - UNITS</option>
                              <option value="BDL">BDL - BUNDLES</option>
                              <option value="BTL">BTL - BOTTLES</option>
                              <option value="CAN">CAN - CANS</option>
                              <option value="CTN">CTN - CARTONS</option>
                              <option value="DOZ">DOZ - DOZEN</option>
                              <option value="GMS">GMS - GRAMS</option>
                              <option value="KLR">KLR - KILOLITER</option>
                              <option value="TON">TON - TONNES</option>
                              <option value="PAC">PAC - PACKS</option>                              
                              <option value="OTH">OTH - OTHERS</option>
                            </select>
                        </td>
                      </tr>
                      <tr>
                        <td className="cell-left">GST Rate</td>
                        <td><input type="text" value={selectedCode.GST_rate} onChange={(e) => setSelectedCode({ ...selectedCode, GST_rate: e.target.value.replace(/[^0-9]/g, 0).slice(0, 2) })} /></td>
                      </tr>
                      <tr>
                          <td className="cell-left">Category</td>
                          <td><select
                                value={selectedCode.GST_pcat_id}
                                onChange={(e) => setSelectedCode({ ...selectedCode, GST_pcat_id: e.target.value })}
                              >
                                <option value="">Select Category</option>
                                {catlist.map((catlist) => (
                                    <option key={catlist.pcat_Id} value={catlist.pcat_id}>
                                      {catlist.pcat_Ename}
                                    </option>
                                ))}
                              </select>
                          </td>                      
                        </tr>
                    </table>
                  </div>
                  <div style={{ display: 'flex', justifyContent: 'space-between', width: '100%' }}>
                    <Button color="success" style={{ flex: 1, marginRight: '10px' }} onClick={handleAddCode} disabled={!selectedCode.GST_hsn_code || !selectedCode.GST_goods_name || !selectedCode.GST_unit || !selectedCode.GST_rate || !selectedCode.GST_pcat_id}>
                      Submit
                    </Button>
                    <Button color="primary" style={{ flex: 1 }} onClick={() => setAddModalVisible(false)}>
                      Close
                    </Button>
                  </div>
                
              </ModalBody>
            </Modal>  

    </div>
  );
};

export default PartyMaster;
